import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface OrderOverviewSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const OrderOverviewSearch = ({
  value,
  onChange,
}: OrderOverviewSearchProps) => {
  return (
    <div className="relative w-full md:w-96">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="ค้นหารหัสคำสั่งซื้อ, ชื่อลูกค้า, รหัสนักเรียน..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-10"
      />
    </div>
  );
};
